export interface Article {
  id: string;
  title: string;
  slug: string;
  excerpt: string;
  content: string;
  categoryId: string;
  categorySlug: string;
  categoryName: string;
  imageUrl: string;
  author: string;
  publishedAt: string;
  readTime: number;
  tags: string[];
  featured: boolean;
  rating: number;
  views: number;
}

export const articles: Article[] = [
  {
    id: 'art-1',
    title: '《沙丘：第二部分》深度解读：保罗·厄崔迪的命运转折与沙漠史诗',
    slug: 'dune-part-two-deep-analysis',
    excerpt: '丹尼斯·维伦纽瓦执导的科幻巨制《沙丘：第二部分》延续第一部的恢弘叙事，深入探讨了保罗·厄崔迪在弗雷曼人中的崛起之路。本文从叙事结构、视觉美学、角色发展三个维度全面解析这部年度科幻大作。',
    content: '',
    categoryId: 'cat-1',
    categorySlug: 'zone-one',
    categoryName: '欧美一区',
    imageUrl: 'https://readdy.ai/api/search-image?query=Cinematic%20desert%20landscape%20with%20epic%20scale%2C%20warm%20golden%20sand%20dunes%2C%20dramatic%20sunset%20lighting%2C%20science%20fiction%20movie%20aesthetic%2C%20majestic%20wide%20shot%2C%20atmospheric%20haze%2C%20Dune%20inspired%20visual&width=800&height=450&seq=art-dune&orientation=landscape',
    author: '影评人·李明',
    publishedAt: '2026-08-08',
    readTime: 12,
    tags: ['科幻', '沙丘', '好莱坞', '丹尼斯·维伦纽瓦', '奥斯卡'],
    featured: true,
    rating: 4.8,
    views: 12580,
  },
  {
    id: 'art-2',
    title: '2026年最值得期待的10部欧美剧集：从史诗奇幻到现实题材',
    slug: 'top-10-anticipated-series-2026',
    excerpt: '新一年的欧美剧集阵容堪称豪华，HBO、Netflix、Apple TV+等平台纷纷亮出王牌。我们为你盘点2026年最值得期待的10部欧美剧集，涵盖奇幻、科幻、悬疑、历史等多个类型。',
    content: '',
    categoryId: 'cat-1',
    categorySlug: 'zone-one',
    categoryName: '欧美一区',
    imageUrl: 'https://readdy.ai/api/search-image?query=TV%20series%20collage%20visual%20with%20warm%20cinematic%20lighting%2C%20streaming%20platform%20aesthetic%2C%20diverse%20genre%20mashup%2C%20premium%20television%20production%20style%2C%20dramatic%20composition%2C%20rich%20amber%20tones&width=800&height=450&seq=art-series-2026&orientation=landscape',
    author: '编辑·王芳',
    publishedAt: '2026-08-06',
    readTime: 8,
    tags: ['剧集', 'HBO', 'Netflix', '2026', '推荐'],
    featured: true,
    rating: 4.6,
    views: 9870,
  },
  {
    id: 'art-3',
    title: '独立电影之光：2026年圣丹斯电影节获奖作品全览',
    slug: 'sundance-2026-winners',
    excerpt: '2026年圣丹斯电影节再次为全球影迷带来了众多惊喜，多部独立电影凭借独特的视角和精湛的叙事脱颖而出。本文带你一览本届电影节最受瞩目的获奖作品。',
    content: '',
    categoryId: 'cat-2',
    categorySlug: 'zone-two',
    categoryName: '欧美二区',
    imageUrl: 'https://readdy.ai/api/search-image?query=Film%20festival%20atmosphere%20with%20snowy%20mountain%20backdrop%2C%20warm%20cabin%20glow%2C%20independent%20cinema%20aesthetic%2C%20creative%20community%20vibe%2C%20Sundance%20inspired%20visual%2C%20cozy%20winter%20lighting&width=800&height=450&seq=art-sundance&orientation=landscape',
    author: '特约记者·张伟',
    publishedAt: '2026-08-04',
    readTime: 10,
    tags: ['独立电影', '圣丹斯', '电影节', '文艺片'],
    featured: true,
    rating: 4.5,
    views: 6340,
  },
  {
    id: 'art-4',
    title: '欧美动作片进化史：从硬汉时代到超级英雄纪元',
    slug: 'evolution-of-action-movies',
    excerpt: '从史泰龙的《第一滴血》到如今的漫威宇宙，欧美动作电影经历了几十年的演变。技术进步、审美变迁、全球化浪潮如何重塑了这一类型？让我们一起回顾这段精彩历程。',
    content: '',
    categoryId: 'cat-3',
    categorySlug: 'action-adventure',
    categoryName: '动作冒险',
    imageUrl: 'https://readdy.ai/api/search-image?query=Action%20movie%20evolution%20visual%20with%20vintage%20and%20modern%20contrast%2C%20warm%20retro%20film%20tones%2C%20classic%20Hollywood%20action%20hero%20aesthetic%2C%20dynamic%20composition%2C%20film%20history%20collage%20style&width=800&height=450&seq=art-action-evo&orientation=landscape',
    author: '资深影评·刘洋',
    publishedAt: '2026-08-02',
    readTime: 15,
    tags: ['动作片', '好莱坞', '电影史', '超级英雄'],
    featured: false,
    rating: 4.3,
    views: 7520,
  },
  {
    id: 'art-5',
    title: '《星际穿越》十年后再审视：诺兰的科幻哲学与人文关怀',
    slug: 'interstellar-ten-years-review',
    excerpt: '克里斯托弗·诺兰的《星际穿越》上映已逾十年，这部融合了黑洞理论、时间膨胀与父女情感的科幻巨作，至今仍在影迷心中占据特殊位置。十年后重温，我们有新的发现与感悟。',
    content: '',
    categoryId: 'cat-4',
    categorySlug: 'sci-fi-fantasy',
    categoryName: '科幻奇幻',
    imageUrl: 'https://readdy.ai/api/search-image?query=Deep%20space%20visual%20with%20warm%20starlight%20glow%2C%20cosmic%20wormhole%20aesthetic%2C%20sci-fi%20movie%20cinematography%2C%20vast%20galaxy%20backdrop%2C%20emotional%20atmosphere%2C%20Interstellar%20inspired%20composition&width=800&height=450&seq=art-interstellar&orientation=landscape',
    author: '科学顾问·陈博士',
    publishedAt: '2026-07-30',
    readTime: 11,
    tags: ['科幻', '诺兰', '星际穿越', '经典回顾'],
    featured: false,
    rating: 4.9,
    views: 11340,
  },
  {
    id: 'art-6',
    title: '北欧悬疑剧崛起：《桥》与《困兽》如何改变犯罪剧格局',
    slug: 'nordic-noir-rise',
    excerpt: '北欧悬疑剧（Nordic Noir）以其冷峻的视觉风格、复杂的人物塑造和社会批判意识，在全球范围内收获了大量忠实粉丝。本文深入分析这一类型的代表作品与独特魅力。',
    content: '',
    categoryId: 'cat-5',
    categorySlug: 'drama-thriller',
    categoryName: '剧情悬疑',
    imageUrl: 'https://readdy.ai/api/search-image?query=Moody%20Scandinavian%20landscape%20with%20foggy%20bridge%2C%20dark%20atmospheric%20lighting%2C%20Nordic%20noir%20crime%20drama%20aesthetic%2C%20cold%20and%20warm%20tone%20contrast%2C%20minimalist%20composition%2C%20suspenseful%20cinematic%20style&width=800&height=450&seq=art-nordic-noir&orientation=landscape',
    author: '文化观察·赵敏',
    publishedAt: '2026-07-28',
    readTime: 9,
    tags: ['悬疑', '北欧', '犯罪剧', '剧集推荐'],
    featured: false,
    rating: 4.4,
    views: 5210,
  },
  {
    id: 'art-7',
    title: '法式浪漫喜剧精选：十部让你笑中带泪的法国电影',
    slug: 'french-romantic-comedy-top10',
    excerpt: '法国喜剧电影以其独特的幽默感和生活哲学，在全球影坛独树一帜。从经典老片到近年新作，我们精选十部最能代表法式浪漫喜剧精神的佳作推荐给你。',
    content: '',
    categoryId: 'cat-6',
    categorySlug: 'comedy-romance',
    categoryName: '喜剧爱情',
    imageUrl: 'https://readdy.ai/api/search-image?query=Parisian%20street%20scene%20with%20warm%20golden%20afternoon%20light%2C%20romantic%20cafe%20terrace%2C%20French%20cinema%20aesthetic%2C%20whimsical%20and%20joyful%20atmosphere%2C%20soft%20pastel%20color%20palette%2C%20charming%20composition&width=800&height=450&seq=art-french-comedy&orientation=landscape',
    author: '编辑·周婷',
    publishedAt: '2026-07-25',
    readTime: 7,
    tags: ['喜剧', '法国电影', '爱情', '推荐'],
    featured: false,
    rating: 4.2,
    views: 4890,
  },
  {
    id: 'art-8',
    title: '欧美影视中的女性力量：从银幕形象到产业变革',
    slug: 'women-in-film-industry',
    excerpt: '近年来，欧美影视产业中女性导演、编剧、制片人的声音越来越响亮，银幕上的女性形象也愈发多元和立体。这是一场正在发生的深刻变革。',
    content: '',
    categoryId: 'cat-2',
    categorySlug: 'zone-two',
    categoryName: '欧美二区',
    imageUrl: 'https://readdy.ai/api/search-image?query=Film%20director%20on%20movie%20set%20with%20warm%20professional%20lighting%2C%20cinematic%20production%20atmosphere%2C%20empowering%20visual%2C%20behind%20the%20scenes%20movie%20making%20aesthetic%2C%20golden%20hour%20studio%20glow&width=800&height=450&seq=art-women-film&orientation=landscape',
    author: '文化评论·林小红',
    publishedAt: '2026-07-22',
    readTime: 13,
    tags: ['女性电影', '产业分析', '性别平等', '文化'],
    featured: false,
    rating: 4.6,
    views: 6780,
  },
  {
    id: 'art-9',
    title: '2026暑期档欧美大片票房盘点：谁主沉浮？',
    slug: 'summer-2026-box-office',
    excerpt: '2026年暑期档竞争激烈，多部欧美大片轮番上映。从超级英雄到动画续集，从科幻冒险到恐怖惊悚，我们为你带来最全面的票房分析与口碑解读。',
    content: '',
    categoryId: 'cat-1',
    categorySlug: 'zone-one',
    categoryName: '欧美一区',
    imageUrl: 'https://readdy.ai/api/search-image?query=Summer%20blockbuster%20movie%20theater%20visual%20with%20vibrant%20warm%20lighting%2C%20crowded%20cinema%20entrance%2C%20Hollywood%20premiere%20atmosphere%2C%20excitement%20and%20energy%2C%20colorful%20movie%20posters%2C%20festive%20composition&width=800&height=450&seq=art-summer-2026&orientation=landscape',
    author: '数据分析·黄强',
    publishedAt: '2026-08-09',
    readTime: 8,
    tags: ['票房', '暑期档', '好莱坞', '2026'],
    featured: true,
    rating: 4.4,
    views: 15020,
  },
  {
    id: 'art-10',
    title: '赛博朋克美学：从《银翼杀手》到《赛博朋克2077》的视觉演变',
    slug: 'cyberpunk-aesthetics-evolution',
    excerpt: '赛博朋克作为一种独特的视觉风格和文化表达，在欧美影视与游戏中有着深远影响。从雷德利·斯科特的《银翼杀手》到近年热门作品，这一美学如何演变与重生？',
    content: '',
    categoryId: 'cat-4',
    categorySlug: 'sci-fi-fantasy',
    categoryName: '科幻奇幻',
    imageUrl: 'https://readdy.ai/api/search-image?query=Cyberpunk%20cityscape%20at%20night%20with%20warm%20neon%20glow%2C%20rain-slicked%20streets%2C%20futuristic%20dystopian%20aesthetic%2C%20Blade%20Runner%20inspired%20visual%2C%20atmospheric%20haze%2C%20cinematic%20composition&width=800&height=450&seq=art-cyberpunk&orientation=landscape',
    author: '视觉设计·吴大师',
    publishedAt: '2026-07-20',
    readTime: 10,
    tags: ['赛博朋克', '银翼杀手', '视觉美学', '科幻'],
    featured: false,
    rating: 4.7,
    views: 8340,
  },
  {
    id: 'art-11',
    title: '谍战经典永不褪色：《谍影重重》系列为何是动作片标杆',
    slug: 'bourne-series-action-benchmark',
    excerpt: '马特·达蒙主演的《谍影重重》系列重新定义了现代动作片的标准，其写实的打斗风格、紧凑的叙事节奏和深刻的人物刻画，至今仍被无数后来者模仿。',
    content: '',
    categoryId: 'cat-3',
    categorySlug: 'action-adventure',
    categoryName: '动作冒险',
    imageUrl: 'https://readdy.ai/api/search-image?query=Spy%20thriller%20visual%20with%20European%20city%20backdrop%2C%20intense%20chase%20atmosphere%2C%20warm%20street%20lighting%2C%20espionage%20movie%20aesthetic%2C%20dynamic%20urban%20composition%2C%20Bourne%20series%20inspired%20style&width=800&height=450&seq=art-bourne&orientation=landscape',
    author: '动作片迷·陈刚',
    publishedAt: '2026-07-18',
    readTime: 9,
    tags: ['谍影重重', '动作片', '经典', '马特·达蒙'],
    featured: false,
    rating: 4.5,
    views: 6980,
  },
  {
    id: 'art-12',
    title: '英国时代剧的魅力：从《唐顿庄园》到《王冠》的贵族世界',
    slug: 'british-period-dramas',
    excerpt: '英国时代剧以其精致的服化道、优雅的英伦风情和深厚的历史底蕴，吸引了全球无数观众。从《唐顿庄园》到《王冠》，这些作品如何将历史与戏剧完美融合？',
    content: '',
    categoryId: 'cat-5',
    categorySlug: 'drama-thriller',
    categoryName: '剧情悬疑',
    imageUrl: 'https://readdy.ai/api/search-image?query=British%20period%20drama%20visual%20with%20elegant%20manor%20house%2C%20warm%20candlelit%20interior%2C%20Downton%20Abbey%20inspired%20aesthetic%2C%20vintage%20English%20countryside%2C%20refined%20aristocratic%20atmosphere%2C%20soft%20classical%20lighting&width=800&height=450&seq=art-british-period&orientation=landscape',
    author: '历史爱好者·孙丽',
    publishedAt: '2026-07-15',
    readTime: 11,
    tags: ['英剧', '时代剧', '唐顿庄园', '王冠'],
    featured: false,
    rating: 4.3,
    views: 5670,
  },
];